// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"price_wrapper__D8PsI","original":"price_original__DIajY","new":"price_new__vmybR"};